import type { ProductName } from '@atlassian/jira-shared-types';
import { useApplicationPermissions } from '../application-permissions';
import { getProductName } from './utils';

export const useProductName = (): ProductName => {
	const appPermissions = useApplicationPermissions();
	return getProductName(appPermissions);
};
